import { createPinia } from "pinia"

export const createStore = () => createPinia()
